export const BREAKPOINTS = {
  mobile: {
    min: 0,
    max: 750,
  },
  mobileUp: {
    min: 0,
    max: null,
  },
  tabletDown: {
    min: 0,
    max: 1080,
  },
  tablet: {
    min: 751,
    max: 1080,
  },
  tabletUp: {
    min: 751,
    max: null,
  },
  desktopDown: {
    min: 0,
    max: 1440,
  },
  desktop: {
    min: 1081,
    max: 1440,
  },
  desktopUp: {
    min: 1081,
    max: null,
  },
  wide: {
    min: 1440,
    max: -1,
  },
};

export type MediaType =
  | 'mobile'
  | 'tablet'
  | 'desktop'
  | 'wide'
  | 'mobileUp'
  | 'tabletUp'
  | 'tabletDown'
  | 'desktopDown'
  | 'desktopUp';
